import { AbstractControl, ValidationErrors } from '@angular/forms';

export function phoneNumberValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const value = (control.value || '').trim();

  return !value || /^\+?\d{1,4}\s?\d{6,15}$/.test(value)
    ? null
    : { phoneNumber: true };
}
